export class Base {
  public selector?: string = "";

  constructor({ selector }: Base = {}) {
    this.selector = selector;
  }
}
